import styled, { css } from 'styled-components';
import { rgba } from 'polished';

const BASE_ITEM_STYLE = css`
  border: 1px dashed #62ab81;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;
`;

export const EventItemSC = styled.div<{
  ordered?: boolean;
  editing?: boolean;
  textColor: string;
  backgroundColor: string;
}>`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  font-weight: bold;

  .content {
    padding: 2px 4px;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    .name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    ${({ ordered, editing, textColor, backgroundColor }) => {
      if (editing) {
        return css`
          ${BASE_ITEM_STYLE};
          font-weight: 800;
          background: ${backgroundColor};
          color: ${textColor};
          border: 1px solid transparent;
        `;
      } else if (ordered) {
        return css`
          ${BASE_ITEM_STYLE};
          font-weight: 800;
          border: 1px solid transparent;
          background: ${backgroundColor};
          color: ${textColor};
        `;
      } else {
        return css`
          ${BASE_ITEM_STYLE};
          border: 1px solid dashed ${backgroundColor};
          background: ${rgba(backgroundColor, 0.2)};
          color: ${textColor};
        `;
      }
    }}
  }
`;
